// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__32_Jo","titleShimmer":"styles_titleShimmer__6qjNZ","cardsContainer":"styles_cardsContainer__OfPTi","cardShimmer":"styles_cardShimmer__lUdlU"};